<template>
  <v-list-item two-line align="center">
    <v-list-item-content>
      <v-avatar size="164">
        <img class="center" src="@/assets/Author/hold.jpg" />
      </v-avatar>
      <v-list-item-title class="title">{{author.name}}</v-list-item-title>
      <v-list-item-subtitle>{{author.title}}</v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  props: ["author"],
  data: () => ({})
};
</script>